<template>
  <div class="creativeUnits">

    <spinner v-if="loading" />

    <breadcrumb :links="breadcrumb" />
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">{{ creativeUnitName }} <span class="text-uppercase">({{ creativeUnitType }})</span>
          <span v-if="approvalRequested" style="font-size: 75% !important;">
            <span class="label label-pill label-warning">
              Approval Requested
            </span>
          </span>
          <span v-if="needToShowApproved" style="font-size: 75% !important;">
            <span class="label label-pill label-success">
              Approved
            </span>
          </span>
        </span>
      </heading-wrap>
      <div class="row">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title"><span  v-if="campaignJobNumber">Campaign Job Number: {{ campaignJobNumber }} | </span> Campaign Status: <span v-if="status" class="label label-pill label-warning">Archived</span><span v-else class="label label-pill label-success">Active</span>  <span v-if="creativeJobNumber">| Creative Job Number: {{ creativeJobNumber }}</span></h5>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <creative-unit-form
              v-if="creativeUnits.data"
              :action="`${baseUrl}api_v2/creative/${creativeId}/bulk`"
              :type="creativeUnitType"
              :selectedUnits="getSelected()"
              :isDownloadDisabled="creativeUnits.data.creative.need_download_approval"
              :isClient="isClient"
              @actionChange="onActionChange"
              @launchChargeModal="onLaunchChargeModal"
              @launchAdTagModal="onLaunchAdTagModal"
              @launchSendToCreativeModal="onLaunchSendToCreativeModal"
              @launchHtmlToVideoOptionsModal="onLaunchHtmlToVideoOptionsModal"
              @renderHtmlToVideoOptionsModal="onLaunchHtmlToVideoOptionsModal"
              @launchBulkEditModal="onLaunchBulkEditModal"
              @launchBulkCopyUnitModal="onLaunchBulkCopyUnitModal"
              @launchShareCreateLinkModal="onLaunchShareCreateLinkModal"
          />
          <div class="creativeUnits__search">
            <input class="input-search form-control mr-sm-2" type="text" ref="search-input" placeholder="Search..." @keyup="triggerSearch"/>
            <a href="javascript:;" v-if="creativeUnitsSearchTerms" @click="clearSearch" >clear search</a>
          </div>
        </div>
        <div class="col-sm-6">
          <span slot="link" class="creativeUnits__buttons">
            <button-cta class="btn btn-success" v-if="isAdminApprove" :data-modalId="creativeId" data-modalType="approveCreativeDownloads" :onClick="onLaunchModal">
            Approve
            </button-cta>
            <button-cta class="btn btn-success" v-if="requiresApproval" data-modalType="requestCreativeDownloadApproval" :onClick="onLaunchModal">
            Request Approval
            </button-cta>
            <!--             <button-cta :onClick="launchAddUnitModal" @click="updateImage"-->
            <!--                         data-modalType="assetLibrary">-->
            <!--              <i class="fa fa-plus" aria-hidden="true"></i> Add AE Footage Library-->
            <!--            </button-cta>-->
            <button-cta data-modalType="addUnit" :onClick="launchAddUnitModal">
              <i class="fa fa-plus" aria-hidden="true"></i> Add New Unit
            </button-cta>
            <!--<upload-file ctaText="Update Master AE File" icon="upload" @input="overwriteMasterFile" acceptedFileType=".zip" />-->
            <!--<button-cta data-modalType="encodingProfile" :onClick="launchEncodingProfileModal">
              Add Encoding Profile
            </button-cta>-->
            <!--<button-cta data-modalType="footageLibrary" :onClick="launchFootageLibraryModal">
              Footage Library
            </button-cta>-->
            <button-cta v-if="creativeUnitType === 'after-effects' && !isClient" :onClick="changeAeFile">Update AE File</button-cta>
            <upload-file ctaText="Upload CSV" icon="upload" @input="onUploadCsv" acceptedFileType=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv" />
            <button-cta v-if="creativeHasFootage" title="Asset Library" data-modalType="assetLibrary" :onClick="onLaunchModal">
              <i class="fa fa-photo" aria-hidden="true"></i>
              Footage
            </button-cta>
            <span v-if="creativeUnitType === 'after-effects'">
            <button-cta v-if="!creativeHasFootage" title="Footage Library" data-modalType="footageLibrary" :onClick="onLaunchModal">
              <i class="fa fa-photo" aria-hidden="true"></i>
              Footage Upload
            </button-cta>
              </span>
            <button-cta v-if="creativeUnitType !== 'after-effects'" title="Asset Library" data-modalType="assetLibrary" :onClick="onLaunchModal">
              <i class="fa fa-photo" aria-hidden="true"></i>
              Asset Library
            </button-cta>
            <button-cta  v-if="hasDownloads" title="Download History" data-modalType="downloadHistory" :onClick="onLaunchModal">
              <i class="fa fa-download" aria-hidden="true"></i> Download History
            </button-cta>
            <button-cta title="Reviews History" data-modalType="reviewLinkHistory" :onClick="onLaunchModal">
              <i class="fa fa-tasks" aria-hidden="true"></i> Reviews History
            </button-cta>
            <button-cta  v-if="hasTags" title="Tags" :onClick="openTags">
              <i class="fa fa-tags" aria-hidden="true"></i> Tags
            </button-cta>
            <div :class="`btn-group${buttonDropdown ? ' open' : ''}`">
              <button-cta type="button" :onClick="buttonToggle" class="btn btn-success dropdown-toggle">
                <i class="fa fa-download" aria-hidden="true"></i> <span class="caret"></span>
              </button-cta>
              <ul class="dropdown-menu" role="menu">
                <li><a @click.prevent="downloadTemplateCsvAction">CSV Template</a></li>
                <li v-if="!isClient"><a @click.prevent="downloadMasterZipAction">Master Zip</a></li>
                <li v-if="!isClient && (creativeUnitType === 'after-effects')"><a @click.prevent="downloadConfigAndLayerJsonAction">Config Json Files</a></li>
                <li v-if="!isClient"><a @click.prevent="onLaunchAssetsSendToCreativeModal" :data-copy-action="'push'">Copy Assets to Campaign</a></li>
                <li v-if="!isClient"><a @click.prevent="onLaunchAssetsSendToCreativeModal" :data-copy-action="'pull'">Copy Assets from Campaign</a></li>
              </ul>
            </div>
          </span>
        </div>
      </div>
      <creative-unit-table
          v-if="creativeUnits.data"
          :tableData="this.creativeData"
          :tableFields="table.fields"
          :tableFieldTypes="table.fieldTypes"
          :tableSortList="table.sortList"
          :columnData="table.columns"
          :mastersData="creativeUnits.data.masters"
          :compositionData="creativeUnits.data.compositions"
          :encodingProfileData="creativeUnits.data.encoding_profiles"
          :creative="creativeUnits.data.creative"
          :tableAllowedSortColumns="allowedSortColumns"
          :tableActiveSortData="creativeUnitsSorting"
          v-model="this.creativeData"
          @onEditRow="editRow"
          @onDeleteRow="deleteRow"
          @onCopyRow="copyRow"
          @onCancelRow="cancelRow"
          @onUpdateImage="updateImage"
          @onPreview="previewImage"
          @onToggleParentCheckboxes="toggleUnitCheckboxes"
          @onSortTableData="sortTableData"
          @onStatusChangeToEdited="onStatusChangeToEdited"
          @onDispatchSortEvent="onSortTableEventDispatched"/>
      <div class="row">
        <div class="pull-right">
          <pager :pagerData="creativeUnitsPager"
                 :onPaginate="onPaginateCreativeUnits"
                 :onChangePageSize="onChangePageSizeCreativeUnits"
                 :minItemsPerPage="creativeUnitsPager.pageSize"
                 ref="creativeUnitsPagerRef"
          />
        </div>
      </div>
    </div>
    <portal to="globalModal">
      <modal-bulk-edit-unit
          v-if="bulkEditModal.show"
          :tableFields="table.fields"
          :tableColumns="table.columns"
          :tableFieldTypes="table.fieldTypes"
          :tableData="this.creativeData"
          :show="showModal.bulkEditUnit"
          :selected="this.getSelected"
          :mastersData="creativeUnits.data.masters"
          :creativeUnitType="this.creativeUnitType"
          ref="bulkEditModalRef"
          :creative="creativeUnits.data.creative"
          :triggerBulkEdit="this.bulkEdit"
          @onUpdateImage="updateImage"
          @close="onCloseBulkEditModal"/>
      <modal-bulk-copy-unit
          v-if="bulkCopyUnitModal.show"
          :show="showModal.bulkCopyCreativeUnit"
          :confirmId="modalId"
          @confirmBulkCopyUnit="onConfirmBulkCopyUnit"
          @close="onCloseBulkCopyUnitModal"
      />
      <modal-asset-library v-if="creativeUnits.data" :show="showModal.assetLibrary" :type="modalType" :confirmId="modalId" :field="modalField" :fieldType="modalFieldType" :creativeUnitType="creativeUnitType" @selectImage="onSelectImage" @close="toggleModal('assetLibrary')" :forceReloadAssetsLibraryData="forceReloadAssetsLibraryData" :footageStructure="creativeFootageFolder" :masters="creativeUnits.data.creative.masters"/>
      <modal-footage-library v-if="creativeUnitType === 'after-effects'" :show="showModal.footageLibrary" :type="modalType" :confirmId="modalId" :field="modalField" :fieldType="modalFieldType" @selectImage="onSelectImage" @close="toggleModal('footageLibrary')" :forceReloadFootageLibraryData="forceReloadFootageLibraryData" :hasFootage="creativeHasFootage" :footageStructure="creativeFootageFolder" :masters="creativeUnits.data.creative.masters"/>
      <modal-download-history :show="showModal.downloadHistory" :type="modalType" :title="creativeUnitName" :confirmId="modalId" @close="toggleModal('downloadHistory')"/>
      <modal-delete-unit :show="showModal.deleteCreativeUnit" :type="modalType" :confirmId="modalId" @close="toggleModal('deleteCreativeUnit')" @confirmDeleteUnit="onConfirmDeleteUnit"/>
      <modal-change-ae-file v-if="creativeUnits.data" :show="showModal.changeAeFile" :type="modalType" :confirmId="creativeUnits.data.creative.hash_id" @close="toggleModal('changeAeFile')" />
      <modal-approve-creative-downloads :show="showModal.approveCreativeDownloads" :type="modalType" :confirmId="modalId" @close="toggleModal('approveCreativeDownloads')"/>
      <modal-request-download-approval v-if="creativeUnits.data" :show="showModal.requestCreativeDownloadApproval" :type="modalType" :confirmId="creativeUnits.data.creative.hash_id" @close="toggleModal('requestCreativeDownloadApproval')"/>
      <modal-copy-unit :show="showModal.copyCreativeUnit" :type="modalType" :confirmId="modalId" @close="toggleModal('copyCreativeUnit')" @confirmCopyUnit="onConfirmCopyUnit" :locale="modalField" />
      <modal-preview-link v-if="showModal.previewLink" :show="showModal.previewLink" :type="modalType" :confirmId="modalId" :responseData="modalData" @close="toggleModal('previewLink')" />
      <modal-adtag-link :show="showModal.adtagLink" :type="modalType" :confirmId="modalId" @close="toggleModal('adtagLink')" />
      <modal-send-to-creative :show="showModal.sendToCreative" :type="modalType" :confirmId="modalId" :field="this.sendToOptions" :currentCreativeId="creativeId" @close="toggleModal('sendToCreative')" @sendToCreativeConfirm="onSendToCreativeConfirm" @assetsCopyToCreativeConfirm="onAssetsCopyToCreativeConfirm"/>
      <modal-charge-confirmation :show="showModal.chargeConfirmation" :type="modalType" :confirmId="modalId" :charges="charges" :creativeUnitType="creativeUnitType" :tableColumns="table.columns" @close="toggleModal('chargeConfirmation')" @onAcceptCharge="onAcceptCharge"/>
      <modal-adtag-confirmation :show="showModal.adtagConfirmation" :type="modalType" :confirmId="modalId" :charges="charges" :creativeUnitType="creativeUnitType" :tableColumns="table.columns" @close="toggleModal('adtagConfirmation')" @adTagCreateConfirm="onAdTagCreateConfirm"/>
      <modal-add-unit :show="showModal.addUnit" :type="modalType" :confirmId="modalId" :masters="masters" :compositions="compositions" :creativeUnitType="creativeUnitType" @close="toggleModal('addUnit')" @addUnit="onAddUnit"/>
      <!--      <modal-footage-library :show="showModal.footageLibrary" :type="modalType" :confirmId="modalId" :masters="masters" :creativeUnitType="creativeUnitType" @close="toggleModal('footageLibrary')" @addUnit="onFootageLibrary"/>-->
      <modal-encoding-profile :show="showModal.encodingProfile" :type="modalType" :confirmId="modalId" :masters="masters" :creativeUnitType="creativeUnitType" @close="toggleModal('encodingProfile')" />
      <modal-render-html-video :show="showModal.htmlToVideoRenderOptions" @close="toggleModal('htmlToVideoRenderOptions')"/>
      <modal-create-preview-link
          v-if="showModal.createPreviewLink"
          :creativeData="this.creativeUnits"
          :selectedUnitsIds="this.getSelected().ids"
          :show="showModal.createPreviewLink"
          :type="modalType"
          :confirmId="modalId"
          @actionChange="onActionChange"
          @close="toggleModal('createPreviewLink')" />
      <modal-review-link-history
          v-if="showModal.reviewLinkHistory"
          :show="showModal.reviewLinkHistory"
          :creativeId="creativeId"
          @close="toggleModal('reviewLinkHistory')" />
      <model-change-status-prompt :show="showModal.changeStatusToEdited" @confirm="onStatusChangeToApproved" :creativeId="creativeId" :confirmId="modalId" :type="modalType" @close="toggleModal('changeStatusToEdited')"/>
    </portal>

    <lightbox
        :images="lightbox.previewItems"
        :showThumbs="false"
        showCaption
        v-if="lightbox.config.showLightBox"
        :startAt="lightbox.config.startAt"
        @closeLightbox="toggleLightbox"
    >
    </lightbox>
  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {profileMixin} from '@/mixins/profileMixin'
import {downloadMixin} from '@/mixins/downloadMixin'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import Field from '@/components/Form/Field/field'

import UploadFile from '@/components/UploadFile/upload-file'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import ModalAssetLibrary from '@/components/Modal/assets/modal-asset-library'
import ModelChangeStatusPrompt from '@/components/Modal/creatives/model-change-status-prompt'
import ModalFootageLibrary from '@/components/Modal/footage/modal-footage-library'
import ModalDownloadHistory from '@/components/Modal/downloads/modal-download-history'
import ModalDeleteUnit from '@/components/Modal/creatives/modal-delete-creativeUnit'
import ModalSendToCreative from '@/components/Modal/creatives/modal-send-to-creative'
import ModalCopyUnit from '@/components/Modal/creatives/modal-copy-creativeUnit'
import ModalPreviewLink from '@/components/Modal/creatives/modal-preview-link'
import ModalAdtagLink from '@/components/Modal/creatives/modal-adtag-link'
import ModalAddUnit from '@/components/Modal/creatives/modal-add-unit'
import ModalEncodingProfile from '@/components/Modal/encoding-profile/encoding-modal'
import ModalChargeConfirmation from '@/components/Modal/creatives/modal-charge-confirmation'
import ModalAdtagConfirmation from '@/components/Modal/creatives/modal-adtag-confirmation'
import ModalApproveCreativeDownloads from '@/components/Modal/creatives/modal-approve-creative-downloads'
import CreativeUnitTable from '@/components/CreativeUnitTable/creative-unit-table'
import CreativeUnitForm from '@/components/CreativeUnitForm/creative-unit-form'
import Breadcrumb from '@/components/Breadcrumb/breadcrumb'
import Lightbox from '@/components/Lightbox/lightbox'
import ModalRenderHtmlVideo from '@/components/Modal/creatives/modal-render-html-video'
import ModalBulkEditUnit from '@/components/Modal/creatives/modal-bulk-edit-unit'
import ModalBulkCopyUnit from '@/components/Modal/creatives/modal-bulk-copy-unit'
import ModalCreatePreviewLink from '@/components/Modal/creatives/modal-create-preview-link'
import ModalReviewLinkHistory from '@/components/Modal/links/modal-review-link-history'
import ModalRequestDownloadApproval from '@/components/Modal/creatives/modal-request-download-approval'
import ModalChangeAeFile from '@/components/Modal/creatives/modal-change-ae-file'
import Pager from '@/components/Pager/pager'

import { url, API_URL, AWS_S3_BUCKET } from '@/config'
import {findIndex, propEq, values, assoc, map, filter, find, pluck, zip} from 'ramda'

export default {
  name: 'creativeUnits',
  mixins: [modalMixin, creativeMixin, notificationMixin, downloadMixin, profileMixin],
  components: {
    Breadcrumb,
    HeadingWrap,
    SlotTable,
    ButtonCta,
    Spinner,
    ModalAssetLibrary,
    ModalDeleteUnit,
    ModalSendToCreative,
    ModalDownloadHistory,
    ModalApproveCreativeDownloads,
    ModalCopyUnit,
    ModalPreviewLink,
    ModalRequestDownloadApproval,
    ModalAdtagLink,
    ModalAddUnit,
    ModalFootageLibrary,
    ModalEncodingProfile,
    ModalChargeConfirmation,
    ModalChangeAeFile,
    ModalAdtagConfirmation,
    FormGroup,
    Dropdown,
    Checkbox,
    Field,
    CreativeUnitTable,
    CreativeUnitForm,
    UploadFile,
    Lightbox,
    ModalRenderHtmlVideo,
    ModalBulkEditUnit,
    ModalBulkCopyUnit,
    ModalCreatePreviewLink,
    ModalReviewLinkHistory,
    Pager,
    ModelChangeStatusPrompt
  },
  data: () => ({
    lightbox: {
      config: {
        showLightBox: false,
        startAt: 0
      },
      previewItems: Array
    },
    bulkEditModal: {
      show: false,
      assetLibraryImageSelected: null
    },
    bulkCopyUnitModal: {
      show: false
    },
    creativeData: [],
    table: {
      columns: {},
      fields: [],
      fieldTypes: [],
      rowNumber: 0,
      sortList: [
        {
          name: 'Date created',
          direction: 'desc'
        }
      ]
    },
    polling: {
      time: 3000,
      renderedItems: [],
      getQueuedItems: []
    },
    sendToOptions: {
      client: '',
      type: '',
      /**
       * @param {string} copyAction Property to define the action to perform to campaign assets,
       *  - push to send assets to a campaign
       *  - pull to retrieve assets from a campaign
       *  Default value push
       */
      copyAction: 'push'
    },
    postOptions: '', // '{"name_format":["$$master", "_", "$$locale"],"zip":true,"group_by":false,"export_formats":["psd", "gif", "png"]}',
    charges: {
      alreadyDownloaded: 0,
      totalDownloads: 0,
      downloadCost: 0,
      tagCreateCost: 0,
      currency: 'gpb',
      tagUnitCount: 0
    },
    masters: Array,
    buttonDropdown: false,
    forceReloadAssetsLibraryData: false,
    forceReloadFootageLibraryData: false,
    allowedSortColumns: [
      {name: 'Status', key: 'status'},
      {name: 'Date Created', key: 'date_created'},
      'width',
      'height',
      'master',
      'locale',
      'render_video_duration',
      'render_video_fps',
      'render_video_format'
    ],
    searchTimeOutId: undefined,
    compositions: Array
  }),
  async mounted () {
    this.setCreativeUnitsPagerData(null)
    await this.fetchCreativeUnitsData()
  },
  computed: {
    creativeId () {
      return this.$route.params.id
    },
    baseUrl () {
      return url
    },
    creativeUnitType () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.type
      }
    },
    creativeHasFootage () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.hasFootage
      }
    },
    creativeFootageFolder () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.footageFolder
      }
    },
    getPostOptions () {
      return this.postOptions
    },
    creativeUnitName () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.name
      }
    },
    breadcrumb () {
      if (this.creativeUnits.data) {
        return [
          {
            name: this.creativeUnits.data.creative.campaign.client.name,
            path: `client/${this.creativeUnits.data.creative.campaign.client.hash_id}`
          },
          {
            name: this.creativeUnits.data.creative.campaign.name,
            path: `campaigns/${this.creativeUnits.data.creative.campaign.hash_id}`
          },
          {
            name: this.creativeUnits.data.creative.name,
            path: '',
            active: true
          }
        ]
      }
    },
    downloadCost () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.campaign.client.download_cost
      }
    },
    tagCreateCost () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.campaign.client.adtag_create_cost
      }
    },
    currency () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.campaign.client.currency
      }
    },
    status () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.campaign.is_archived
      }
    },
    campaignJobNumber () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.campaign.campaign_job_number
      }
    },
    hasDownloads () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.has_downloads
      }
    },
    hasTags () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.has_tags
      }
    },
    creativeJobNumber () {
      if (this.creativeUnits.data) {
        return this.creativeUnits.data.creative.creative_job_number
      }
    },
    sortedTable () {
      var sortTableTemp = this.creativeData
      return sortTableTemp.sort((a, b) => {
        let modifier = 1
        if (this.table.sortList[0].direction === 'desc') {
          modifier = -1
        }
        var compare = this.table.sortList[0].name.toLowerCase()
        // If its the reserved words
        if (a[compare] < b[compare]) {
          return -1 * modifier
        }
        if (a[compare] > b[compare]) {
          return 1 * modifier
        }
        return 0
      })
    },
    sortedTableByDate () {
      var sortTableTemp = this.creativeData
      return sortTableTemp.sort((a, b) => {
        let modifier = 1
        if (this.table.sortList[0].direction === 'desc') {
          modifier = -1
        }
        // If its the reserved words
        if (a['date_created'].value < b['date_created'].value) {
          return -1 * modifier
        }
        if (a['date_created'].value > b['date_created'].value) {
          return 1 * modifier
        }
        return 0
      })
    },
    sortedTableByFields () {
      var sortTableTemp = this.creativeData
      return sortTableTemp.sort((a, b) => {
        let modifier = 1
        if (this.table.sortList[0].direction === 'desc') {
          modifier = -1
        }
        var compareFields = this.table.sortList[0].name
        if (a.fields[compareFields] < b.fields[compareFields]) {
          return -1 * modifier
        }
        if (a.fields[compareFields] > b.fields[compareFields]) {
          return 1 * modifier
        }
        return 0
      })
    },
    isClient () {
      return this.profileUser && this.profileUser.role === 6
    },
    needToShowApproved () {
      return this.creativeUnits.data && !this.creativeUnits.data.creative.need_download_approval && !this.creativeUnits.data.creative.childs.length && this.creativeUnits.data.creative.parent
    },
    requiresApproval () {
      return this.creativeUnits.data && this.creativeUnits.data.creative.need_download_approval && this.profileUser.role === 6 && this.creativeUnits.data.creative.status !== 'approval_requested'
    },
    approvalRequested () {
      return this.creativeUnits.data && this.creativeUnits.data.creative.status === 'approval_requested' && this.profileUser.role === 6
    },
    isAdminApprove () {
      return this.creativeUnits.data && this.creativeUnits.data.creative.status === 'approval_requested' && (this.profileUser.role === 1 || this.profileUser.role === 4)
    }
  },
  methods: {
    changeAeFile () {
      this.showModal['changeAeFile'] = true
    },
    downloadMasterZipAction () {
      this.startLoading()
      this.createSignedDownloadRequest({
        domain: 'master-zip',
        resource: this.creativeId,
        extension: 'zip'
      }).then(response => {
        this.finishLoading()
        if (!response.success) {
          this.showNotMessage('error', 'Try again later')
          return
        }
        window.open(API_URL + response.link.substring(1))
      }).catch(reason => {
        this.finishLoading()
        this.showNotMessage('error', reason)
      })
    },
    downloadConfigAndLayerJsonAction () {
      this.startLoading()
      this.createSignedDownloadRequest({
        domain: 'config-and-layer-json',
        resource: this.creativeId,
        extension: 'json'
      }).then(response => {
        this.finishLoading()
        if (!response.success) {
          this.showNotMessage('error', 'Try again later')
          return
        }
        window.open(API_URL + response.link.substring(1))
      }).catch(reason => {
        this.finishLoading()
        this.showNotMessage('error', reason)
      })
    },
    downloadTemplateCsvAction () {
      this.startLoading()
      this.createSignedDownloadRequest({
        domain: 'template-csv',
        resource: this.creativeId,
        extension: 'csv'
      }).then(response => {
        this.finishLoading()
        if (!response.success) {
          this.showNotMessage('error', 'Try again later')
          return
        }
        window.open(API_URL + response.link.substring(1))
      }).catch(reason => {
        this.finishLoading()
        this.showNotMessage('error', reason)
      })
    },
    openTags () {
      window.open(`/tags/creative/${this.creativeId}`)
    },
    triggerSearch (evt) {
      if (this.searchTimeOutId) {
        clearTimeout(this.searchTimeOutId)
      }
      const minlength = 1
      this.searchTimeOutId = setTimeout(() => {
        const terms = evt.target.value.trim()
        if (terms.length === 0) {
          this.clearSearch()
          clearTimeout(this.searchTimeOutId)
          return
        }
        if (terms.length < minlength) {
          clearTimeout(this.searchTimeOutId)
          return
        }
        this.setCreativeUnitsSearchTerms(terms === '' ? null : terms)
        this.setCreativeUnitsPagerData(null)
        this.fetchCreativeUnitsData()
        clearTimeout(this.searchTimeOutId)
      }, 1000)
    },
    clearSearch () {
      this.$refs['search-input'].value = ''
      this.setCreativeUnitsSearchTerms(null)
      this.setCreativeUnitsPagerData(null)
      this.fetchCreativeUnitsData()
    },
    async fetchCreativeUnitsData () {
      this.startLoading()

      await this.getCreativeUnits(this.creativeId)

      this.finishLoading()

      // Create table headings
      this.table.fields = []
      this.creativeUnits.data.fields.forEach((item) => {
        this.table.fields.push(item.name)
        this.table.fieldTypes.push(item.type)
      })

      const htmlVideoColumns = {}

      if (this.creativeUnitType === 'html-video') {
        htmlVideoColumns['render_video_duration'] = 'render_video_duration'
        htmlVideoColumns['render_video_fps'] = 'render_video_fps'
        htmlVideoColumns['render_video_format'] = 'render_video_format'
      }

      if (this.creativeUnitType === 'after-effects') {
        this.table.columns = {
          allCheckboxes: 'allCheckboxes',
          creativeActions: '',
          status: 'Status',
          date_created: 'Date created',
          // master: 'master',
          composition: 'composition',
          encoding_profile: 'Encoding Profile',
          locale: 'locale',
          // width: 'width',
          // height: 'height',
          ...htmlVideoColumns,
          ...this.table.fields.reduce((acc, item) => {
            acc[item] = item
            return acc
          }, {})
        }
      } else {
        this.table.columns = {
          allCheckboxes: 'allCheckboxes',
          creativeActions: '',
          status: 'Status',
          date_created: 'Date created',
          master: 'master',
          locale: 'locale',
          width: 'width',
          height: 'height',
          ...htmlVideoColumns,
          ...this.table.fields.reduce((acc, item) => {
            acc[item] = item
            return acc
          }, {})
        }
      }

      this.updateCreativeUnits()
    },
    onSortTableEventDispatched (sortData) {
      this.setCreativeUnitsSortingData(sortData ? {...sortData} : null)
      this.fetchCreativeUnitsData()
    },
    sortTableData (field, preserveOrder) {
      // search for the field in the existing table sort list
      var name = field.name
      var index = 0
      var valObj = this.table.sortList.filter(function (elem) {
        if (elem.name === name) {
          elem['index'] = index
          return elem
        }
        index++
      })
      // Check its the latest one,
      if (valObj.length > 0) {
        // check its not the latest one
        if (this.table.sortList[0].name !== name) {
          // not the current sort order
          index = valObj[0].index
          this.table.sortList.unshift(this.table.sortList.splice(index, 1)[0])
        } else {
          // Current item
          if (this.table.sortList[0].direction === 'asc' && preserveOrder !== true) {
            this.table.sortList[0].direction = 'desc'
          } else {
            this.table.sortList[0].direction = 'asc'
          }
        }
      } else {
        // It doesn exist so put it at the front
        field.direction = 'asc'
        this.table.sortList.unshift(field)
      }
      // sort the table
      var reservedFields = ['Master', 'Locale', 'Status', 'Date created']
      if (reservedFields.indexOf(this.table.sortList[0].name) !== -1) {
        if (this.table.sortList[0].name === 'Date created') {
          this.creativeData = this.sortedTableByDate
        } else {
          this.creativeData = this.sortedTable
        }
      } else {
        this.creativeData = this.sortedTableByFields
      }
      this.updatePreviewLinks()
    },
    updatePreviewLinks () {
      this.lightbox.previewItems = this.previewItems()
    },
    previewItems () {
      if (this.creativeData) {
        const previewArray = []
        this.creativeData.forEach((item) => {
          if (item.previewUrl) {
            if (this.creativeUnitType === 'after-effects') {
              item.previewUrl.forEach((previewUrl, index) => {
                if (!previewUrl) {
                  return
                }
                const previewItem = {
                  src: API_URL + previewUrl,
                  caption: `${item.master} / ${item.locale} / Encoding Profile: ${item.encoding_profile[index].display_name}`,
                  height: item.height,
                  width: item.width,
                  type: previewUrl.split('.').pop() === 'html' ? 'html' : 'image',
                  renderType: this.creativeUnitType
                }
                previewItem.src = AWS_S3_BUCKET + item.videoUrl[index].replace('store/', '') + '?ts=' + Math.round(+new Date() / 1000)
                previewItem.type = item.render_video_format === 'gif' ? 'image' : 'video'
                previewItem['format'] = item.render_video_format
                previewItem['width'] = item.width
                previewItem['height'] = item.height
                previewArray.push(previewItem)
              })
            } else {
              const previewItem = {
                src: API_URL + item.previewUrl + '?ts=' + Math.round(+new Date() / 1000),
                caption: `${item.master} / ${item.locale}`,
                height: item.height,
                width: item.width,
                type: item.previewUrl.split('.').pop() === 'html' ? 'html' : 'image',
                renderType: this.creativeUnitType
              }
              if (this.creativeUnitType === 'html-video') {
                previewItem.src = `${API_URL}${item.videoUrl}/video.${item.render_video_format}?ts=${Math.round(+new Date() / 1000)}`
                previewItem.type = item.render_video_format === 'gif' ? 'image' : 'video'
                previewItem['format'] = item.render_video_format
                previewItem['width'] = item.width
                previewItem['height'] = item.height
              }
              if (this.creativeUnitType === 'after-effects') {
                previewItem.src = AWS_S3_BUCKET + item.videoUrl.replace('store/', '') + '?ts=' + Math.round(+new Date() / 1000)
                previewItem.type = item.render_video_format === 'gif' ? 'image' : 'video'
                previewItem['format'] = item.render_video_format
                previewItem['width'] = item.width
                previewItem['height'] = item.height
              }
              previewArray.push(previewItem)
            }
          }
        })
        return previewArray
      }
    },
    updateCreativeUnits () {
      this.creativeData = [] // reset data
      // get existing row data if any
      const existingUnits = this.creativeUnits.data.units
      this.getExistingUnitRows(existingUnits)
      this.setCreativeUnitsPagerData({
        count: parseInt(this.creativeUnits.data.units_pager.count, 10),
        pagesCount: parseInt(this.creativeUnits.data.units_pager.pagesCount, 10)
      })
      this.$refs.creativeUnitsPagerRef.forceRerender()
    },
    getExistingUnitRows (units) {
      units.forEach((item) => {
        const htmlVideoRowData = {}
        if (this.creativeUnitType === 'html-video') {
          htmlVideoRowData['render_video_duration'] = item.render_video_duration
          htmlVideoRowData['render_video_fps'] = item.render_video_fps
          htmlVideoRowData['render_video_format'] = item.render_video_format
        }
        const existingRow = {
          fields: item.data,
          id: item.id,
          locale: item.locale,
          master: item.master,
          status: item.status,
          width: item.width,
          composition: item.compositions,
          encoding_profile: item.encoding_profiles,
          height: item.height,
          ...htmlVideoRowData,
          date_created: item.date_created,
          status_message: item.status_message,
          previewUrl: item.previewUrl,
          videoUrl: item.videoUrl,
          downloaded: item.is_downloaded,
          editing: false,
          selected: false,
          readOnly: item.readOnly,
          review_link_snapshot: item.review_link_snapshot
        }
        this.creativeData.push(existingRow)
      })
      // var _this = this
      if (!this.allowedSortColumns || this.allowedSortColumns.length === 0) {
        let self = this
        var tempSortList = this.table.sortList.reverse()
        tempSortList.forEach(function (value, index) {
          self.sortTableData(value, true) // set preserve order to be true
        })
      }
      this.updatePreviewLinks()
    },
    onUploadCsv (e) {
      this.startLoading()
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      formData.append('file', files[0])
      const data = {
        id: this.creativeId,
        file: formData
      }
      this.uploadCsv(data).then(() => {
        this.getCreativeUnits(this.creativeId).then(() => {
          this.finishLoading()
          this.updateCreativeUnits()
          this.addNotification('success', 'CSV uploaded.')
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    onAddUnit (choices) {
      this.creativeData.unshift(this.newRow(choices))
      this.table.rowNumber++
      this.flag = 'addUnit'
      this.updateAllUnitRows()
    },
    onFootageLibrary (choices) {
      this.creativeData.unshift(this.newRow(choices))
      this.table.rowNumber++
      this.flag = 'footageLibrary'
      this.updateAllUnitRows()
    },
    onConfirmDeleteUnit (id) {
      const index = findIndex(propEq('id', id))(this.creativeData)
      this.creativeData.splice(index, 1)
      this.updateAllUnitRows(id)
    },
    onConfirmCopyUnit (choices) {
      this.flag = 'clone'
      const originalUnit = filter((item) => {
        if (item.id === choices.originalId) {
          return item
        }
      })(this.creativeData)
      var newUnit = []
      newUnit.master = originalUnit[0].master
      newUnit.locale = choices.locale
      newUnit.width = originalUnit[0].width
      newUnit.height = originalUnit[0].height
      newUnit.fields = originalUnit[0].fields
      newUnit.composition = originalUnit[0].composition
      newUnit.encoding_profile = originalUnit[0].encoding_profile
      if (this.creativeUnitType === 'html-video') {
        newUnit.render_video_duration = originalUnit[0].render_video_duration
        newUnit.render_video_fps = originalUnit[0].render_video_fps
        newUnit.render_video_format = originalUnit[0].render_video_format
      }
      this.creativeData.unshift(this.newRow(newUnit))
      this.table.rowNumber++
      this.updateAllUnitRows()
    },
    onConfirmBulkCopyUnit () {
      this.flag = 'clone'
      const unitSelected = this.getSelected().ids
      const newRows = this.creativeData.map(item => {
        if (unitSelected.includes(item.id)) {
          return {
            ...item,
            locale: item.locale + '_copy',
            id: this.uniqueId()
          }
        }
      }).filter((updatedRows) => updatedRows)
      const allRows = [...this.creativeData, ...newRows]
      this.creativeData = allRows
      this.updateAllUnitRows()
    },
    newRow (choices) {
      const master = choices.masterChosen || choices.master || this.creativeUnits.data.masters[0]
      const composition = choices.composition || choices.composition || this.creativeUnits.data.compositions[0]
      const encodingProfiles = choices.encoding_profile || choices.encoding_profiles || this.creativeUnits.data.encoding_profiles
      const locale = choices.locale || ''
      const width = choices.width || this.creativeUnits.data.units[0].width || 0
      const height = choices.height || this.creativeUnits.data.units[0].height || 0
      const renderVideoDuration = choices.render_video_duration || 0
      const renderVideoFps = choices.render_video_fps || 0
      const renderVideoFormat = choices.render_video_format || 0
      let fields
      if (choices.fields === null || choices.fields === undefined) {
        let defaultValue
        choices.fields = this.table.fields.reduce((acc, item) => {
          defaultValue = this.creativeUnits.data.fields.filter((field) => {
            return item === field.name
          })
          if (this.creativeUnitType === 'html') {
            let masterDefault = defaultValue[0].default_values.find((df) => df.master === master)
            if (masterDefault) {
              acc[item] = masterDefault.value
            } else {
              acc[item] = defaultValue[0].defaultValue
            }
          } else {
            acc[item] = defaultValue[0].defaultValue
          }
          return acc
        }, {})
        fields = choices.fields
      } else {
        fields = choices.fields
      }
      return {
        id: this.uniqueId(),
        isNew: true,
        editing: false,
        allCheckboxes: 'allCheckboxes',
        creativeActions: '',
        status: 'new',
        master: master,
        locale: locale,
        width: width,
        height: height,
        render_video_duration: renderVideoDuration,
        render_video_fps: renderVideoFps,
        render_video_format: renderVideoFormat,
        date_created: new Date(),
        fields: fields,
        composition: composition,
        encoding_profile: encodingProfiles
      }
    },
    bulkEdit () {
      this.flag = 'bulkEdit'
      this.updateAllUnitRows(null)
    },
    onStatusChangeToEdited (e) {
      this.onLaunchModal(e)
    },
    onStatusChangeToApproved (e) {
      this.updateCreativeUnits()
    },
    editRow (e) {
      const existingId = e.currentTarget.dataset.rowid
      let id = findIndex(propEq('id', existingId))(this.creativeData)
      this.creativeData[id].editing = !this.creativeData[id].editing
      // If clicked on save editing,
      // send creative unit to API.
      if (!this.creativeData[id].editing) {
        this.flag = 'edit'
        this.updateAllUnitRows(id)
      }
    },
    deleteRow (e) {
      this.onLaunchModal(e)
    },
    copyRow (e) {
      this.onLaunchModal(e)
    },
    cancelRow () {
      this.startLoading()
      // need to call API again to refresh data
      this.getCreativeUnits(this.creativeId).then(() => {
        this.finishLoading()
        this.updateCreativeUnits()
      })
    },
    updateImage (e) {
      this.onLaunchModal(e)
    },
    previewImage (e) {
      const id = e.currentTarget.dataset.previewid
      const offset = Number(e.currentTarget.dataset.offset)
      const type = e.currentTarget.dataset.type
      const renderedCreativeData = filter((item) => {
        if (item.previewUrl) {
          return item
        }
      })(this.creativeData)
      const index = findIndex(propEq('id', id))(renderedCreativeData)
      this.toggleLightbox()
      if (type === 'after-effects') {
        this.lightbox.config.startAt = index + offset
      } else {
        this.lightbox.config.startAt = index
      }
    },
    toggleLightbox () {
      this.lightbox.config.showLightBox = !this.lightbox.config.showLightBox
    },
    onSelectImage (id, field, image, fieldtype) {
      if (this.bulkEditModal.show) {
        this.$refs.bulkEditModalRef.setAssetLibraryImageSelected(image)
        return false
      }
      const index = findIndex(propEq('id', id))(this.creativeData)
      this.creativeData[index].fields[field] = image
    },
    updateAllUnitRows (id) {
      this.startLoading()
      const data = {
        id: this.creativeId,
        flag: this.flag,
        columns: this.generateUnitColumnsArray(),
        unit: this.generateUnitsArray(id, this.creativeData)
      }
      this.updateCreativeUnit(data).then((response) => {
        this.updateCreativeUnits()
        this.updatePreviewLinks()
        this.finishLoading()
      })
    },
    generateUnitColumnsArray () {
      if (this.creativeUnitType === 'html-video') {
        return ['id', 'master', 'locale', 'width', 'height', 'render_video_duration', 'render_video_fps', 'render_video_format', ...this.table.fields]
      } else if (this.creativeUnitType === 'after-effects') {
        return ['id', 'master', 'locale', 'width', 'height', 'composition', 'encoding_profile', ...this.table.fields]
      }
      return ['id', 'master', 'locale', 'width', 'height', ...this.table.fields]
    },
    generateUnitsArray (id, creativeData) {
      const units = []
      creativeData.forEach((item) => {
        const htmlToVideoProps = {}
        const afterEffectsProps = {}
        if (this.creativeUnitType === 'html-video') {
          htmlToVideoProps['render_video_duration'] = item.render_video_duration
          htmlToVideoProps['render_video_fps'] = item.render_video_fps
          htmlToVideoProps['render_video_format'] = item.render_video_format
        } else if (this.creativeUnitType === 'after-effects') {
          afterEffectsProps['composition'] = item.composition
          afterEffectsProps['encoding_profile'] = item.encoding_profile.map(ep => ep.name || ep)
        }
        const unit = [
          item.id,
          item.master,
          item.locale,
          item.width,
          item.height,
          ...values(htmlToVideoProps),
          ...values(afterEffectsProps),
          ...values(item.fields)
        ]
        units.push(unit)
      })
      return units
    },
    showPreviewModal (response) {
      this.modalData = response
      this.showModal['previewLink'] = true
    },
    showAdTagModal (url) {
      this.modalId = url
      this.showModal['adtagLink'] = true
    },
    onActionChange (e) {
      this.startLoading()
      const action = e.currentTarget.dataset.action
      const options = e.currentTarget.dataset.options || null
      const data = {
        id: this.creativeId,
        action: action,
        units: this.getSelected().ids,
        options: options
      }
      this.updateBulkCreative(data).then((response) => {
        // if response includes preview link show preview link modal
        if (response.preview_url) {
          this.showPreviewModal(response)
        }
        if (response.ad_tag_url) {
          this.showAdTagModal(response.ad_tag_url)
          this.finishLoading()
          return
        }

        if (response.download) {
          this.addNotification('success', `We're proccessing your download request.`)
          this.toggleModal('downloadHistory')
          return
        }

        this.getCreativeUnits(this.creativeId).then(() => {
          this.updateCreativeUnits()
          this.finishLoading()
          if (action === 'render') {
            this.handleCreativePolling()
            this.addNotification('info', 'Creative units sent to queue.')
            return
          } else if (action === 'force-render') {
            this.handleCreativePolling()
            this.addNotification('info', 'Creative units sent to queue.')
            return
          }
          this.addNotification('success', response.reason)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    toggleUnitCheckboxes (toggle) {
      this.creativeData = map(item => assoc('selected', toggle, item), this.creativeData)
    },
    getSelected () {
      const ids = []
      filter(item => {
        if (item.selected) {
          ids.push(item.id)
        }
      }, this.creativeData)
      return {
        ids: ids
      }
    },
    calculateDownloadCharges () {
      let totalDownloads = 0
      let alreadyDownloaded = 0
      let tagUnitCount = 0

      totalDownloads = filter(item => {
        return item.selected && !item.downloaded && item.status === 'rendered'
      }, this.creativeData).length

      alreadyDownloaded = filter(item => {
        return item.selected && item.downloaded
      }, this.creativeData).length

      tagUnitCount = filter(item => {
        return item.selected && item.status === 'rendered'
      }, this.creativeData).length

      const charges = {
        downloadCost: this.downloadCost,
        tagCreateCost: this.tagCreateCost,
        currency: this.currency,
        alreadyDownloaded: alreadyDownloaded,
        totalDownloads: totalDownloads,
        tagUnitCount: tagUnitCount
      }

      this.charges = charges
    },
    buttonToggle () {
      this.buttonDropdown = !this.buttonDropdown
    },
    // Start polling
    handleCreativePolling () {
      // stored queued items in global var so we can compare later
      this.polling.getQueuedItems = this.getFilteredData(this.creativeUnits.data, 'queued')
      if (this.polling.getQueuedItems.length > 0) {
        // if there are queue items hit api every 3 secs to check what's been rendered and then update queue
        setTimeout(() => {
          this.getCreativeUnits(this.creativeId).then(() => {
            this.updateQueue()
          })
        }, this.polling.time)
      }
    },
    onAcceptCharge (options) {
      this.onActionChange({
        currentTarget: {
          dataset: {
            action: 'export-service',
            options: options
          }
        }
      })
    },
    submitPostRequest () {
      /* NEED to find a better way of handling this submit code */
      const form = document.getElementById('creativeUnitForm')
      var input = document.createElement('input')
      input.setAttribute('type', 'hidden')
      input.setAttribute('name', 'options')
      input.setAttribute('value', this.postOptions)
      form.appendChild(input)
      form.submit()
      form.removeChild(input)
    },
    updateQueue () {
      const data = this.creativeUnits.data
      const getQueued = this.getFilteredData(data, 'queued')
      const getRendered = this.getFilteredData(data, 'rendered')
      const getError = this.getFilteredData(data, 'error')
      let currentRendered = []

      getRendered.forEach((item) => {
        // checked not already rendered
        const alreadyExists = find(propEq('id', item.id), this.polling.renderedItems)

        // checked it's a queued item
        const isQueuedItem = find(propEq('id', item.id), this.polling.getQueuedItems)

        if (!alreadyExists && isQueuedItem) {
          this.polling.renderedItems.push(item)
          currentRendered.push(item)
          this.updateCreativeUnits()
        }
      })
      // pluck master name into new array
      // currentRendered = pluck('master', currentRendered)
      currentRendered = zip(pluck('master', currentRendered), pluck('locale', currentRendered))
      // const currentRenderedAppend = (currentRendered.length > 1) ? ' are ' : ' is '
      currentRendered = currentRendered.join(' | ')

      // send message to user with current rendered items
      if (currentRendered) {
        this.addNotification('success', 'Just Rendered:\n\n' + currentRendered.toString())
      }
      if (getError.length > 0) {
        this.getCreativeUnits(this.creativeId).then(() => {
          this.addNotification('success', 'Items are now rendered but With Some Errors.')
        })
      }
      if (getQueued.length > 0) {
        this.handleCreativePolling(data)
        return null
      }
      // no more items to render so lets display success message
      this.getCreativeUnits(this.creativeId).then(() => {
        this.addNotification('success', 'All items are now rendered.')
      })
    },
    getFilteredData (data, type) {
      const queued = (item) => item.status === type
      return filter(queued, data.units)
    },
    // End polling
    onLaunchChargeModal () {
      this.calculateDownloadCharges()
      this.showModal['chargeConfirmation'] = true
    },
    onLaunchAdTagModal () {
      this.calculateDownloadCharges()
      this.showModal['adtagConfirmation'] = true
    },
    onLaunchSendToCreativeModal () {
      this.sendToOptions.client = this.creativeUnits.data.creative.campaign.client
      this.sendToOptions.type = 'actions'
      this.showModal['sendToCreative'] = true
    },
    onLaunchAssetsSendToCreativeModal (e) {
      this.sendToOptions.client = this.creativeUnits.data.creative.campaign.client
      this.sendToOptions.type = 'assets'
      this.sendToOptions.copyAction = e.currentTarget.dataset.copyAction
      this.showModal['sendToCreative'] = true
    },
    onLaunchShareCreateLinkModal (e) {
      this.showModal['createPreviewLink'] = true
    },
    onLaunchBulkEditModal (e) {
      if (!this.creativeUnits.data || this.getSelected().ids.length === 0) {
        const notification = this.addNotification('danger', 'Please select at least 1 unit to continue')
        setTimeout(() => {
          this.closeLastNotification(notification.id)
        }, 15000) // Wait 15 second to remove the notification
        return false
      }
      this.bulkEditModal.show = true
      this.showModal['bulkEditUnit'] = true
    },
    onCloseBulkEditModal () {
      this.toggleModal('bulkEditUnit')
      this.bulkEditModal.show = false
    },
    onLaunchBulkCopyUnitModal (e) {
      if (!this.creativeUnits.data || this.getSelected().ids.length === 0) {
        const notification = this.addNotification('danger', 'Please select at least 1 unit to continue')
        setTimeout(() => {
          this.closeLastNotification(notification.id)
        }, 15000) // Wait 15 second to remove the notification
        return false
      }
      this.bulkCopyUnitModal.show = true
      this.showModal['bulkCopyCreativeUnit'] = true
    },
    onCloseBulkCopyUnitModal () {
      this.toggleModal('bulkCopyCreativeUnit')
      this.bulkCopyUnitModal.show = false
    },
    onLaunchHtmlToVideoOptionsModal (e) {
      this.showModal['htmlToVideoRenderOptions'] = true
    },
    onSendToCreativeConfirm (choices) {
      // Send the action, display back a message on receipt of the request.
      var data = {
        currentTarget: {
          dataset: {
            action: 'send-to-creative',
            options: choices
          }
        }
      }
      this.onActionChange(data)
    },
    onAdTagCreateConfirm (choices) {
      // Send the action, display back a message on receipt of the request.
      var data = {
        currentTarget: {
          dataset: {
            action: 'create-ad-tag-group',
            options: choices
          }
        }
      }
      this.onActionChange(data)
    },
    onAssetsCopyToCreativeConfirm (choices) {
      // Send the action, display back a message on receipt of the request.
      const data = {
        id: this.creativeId,
        options: choices,
        copyAction: this.sendToOptions.copyAction
      }
      this.startLoading()
      this.assetCopyToCreative(data).then((response) => {
        this.addNotification('success', response.reason)
        this.getCreativeUnits(this.creativeId).then(() => {
          this.finishLoading()
          this.updateCreativeUnits()
          const {copyAction} = data
          // this.addNotification('success', `Assets library copied ${copyAction === 'push' ? 'to' : 'from'} other campaign`)
          /**
           * Force trigger an event to the assets library modal to reload the assets library since it was
           * updated with new assets
           */
          if (copyAction === 'pull') {
            this.forceReloadAssetsLibraryData = !this.forceReloadAssetsLibraryData
          }
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    launchAddUnitModal (e) {
      if (this.creativeUnits.data.creative.masters && this.creativeUnits.data.creative.masters.length) {
        this.masters = this.creativeUnits.data.creative.masters.map(master => master.name)
      } else {
        this.masters = this.creativeUnits.data.masters
      }
      if (this.creativeUnitType === 'after-effects') {
        this.compositions = this.creativeUnits.data.compositions
      }
      this.onLaunchModal(e)
    },
    launchFootageLibraryModal (e) {
      if (this.creativeUnits.data.creative.masters && this.creativeUnits.data.creative.masters.length) {
        this.masters = this.creativeUnits.data.creative.masters.map(master => master.name)
      } else {
        this.masters = this.creativeUnits.data.masters
      }
      this.onLaunchModal(e)
    },
    launchEncodingProfileModal (e) {
      if (this.creativeUnits.data.creative.masters && this.creativeUnits.data.creative.masters.length) {
        this.masters = this.creativeUnits.data.creative.masters.map(master => master.name)
      } else {
        this.masters = this.creativeUnits.data.masters
      }
      this.onLaunchModal(e)
    },
    onPaginateCreativeUnits (page, count) {
      if (!this.loading) {
        this.setCreativeUnitsPagerData({ page })
        this.fetchCreativeUnitsData()
      }
    },
    onChangePageSizeCreativeUnits (pageSize) {
      if (!this.loading) {
        this.setCreativeUnitsPagerData({ pageSize, page: 1 })
        this.fetchCreativeUnitsData()
      }
    },
    overwriteMasterFile (e) {
    }
  }
}
</script>

<style lang="scss">
.creativeUnits {
  height:90%;
  &__buttons {
    display: flex;
    justify-content: flex-end;
    max-width: 600px;
    margin-left: auto;
    margin-bottom: 0;
    .btn {
      margin-right: 5px;
    }
    .dropdown-menu {
      left: auto;
      right: 0;
      & li {
        cursor: pointer;
      }
    }
  }
  & form{
    float: left;
  }

  &__search {
    display: flex;
    margin-left: 22rem;
    align-items: center;
    .input-search {
      width: auto;
      margin-right: 1rem;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/creatives/creative-units.vue